const slides = [
    {
      img: require('../../utils/images/slider1.webp'),
      quote:"Dedication. ",
      text:"We are Samdarria..."
    },
    {
      img: require('../../utils/images/slider2.webp'),
      quote:"Commitment. ",
      text:"We are Helping People Find Solutions to their legal problems."

    },
    {
      img: require('../../utils/images/slider3.webp'),
      quote:"Experience. ",
      text:"A lawyer can fight from the side of your opponent as strong as he fought yours."

    },
    {
      img: require('../../utils/images/slider4.webp'),
      quote:"Commitment. ",
      text:"The best lawyer fights the case as if it’s his own."

    },
    {
      img: require('../../utils/images/slider5.webp'),
      quote:"Experience. ",
      text:"A lawyer sees facts above people."

    },
    // {
    //   img: require('../../utils/gallery/6.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/7.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/8.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/9.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/10.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/11.webp'),
    // },
    // {
    //   img: require('../../utils/gallery/12.webp'),
    // },
    // {
    //   img:require("../../utils/gallery/13.webp")
    // },
    // {
    //   img:require("../../utils/gallery/14.webp")
    // },
    // {
    //   img:require("../../utils/gallery/15.webp")
    // },
    // {
    //   img:require("../../utils/gallery/16.webp")
    // },
    // {
    //   img:require("../../utils/gallery/17.webp")
    // },
    // {
    //   img:require("../../utils/gallery/18.webp")
    // },
    // {
    //   img:require("../../utils/gallery/19.webp")
    // },
    // {
    //   img:require("../../utils/gallery/20.webp")
    // },
    // {
    //   img:require("../../utils/gallery/21.webp")
    // },
    // {
    //   img:require("../../utils/gallery/22.webp")
    // },
    // {
    //   img:require("../../utils/gallery/23.webp")
    // },
    // {
    //   img:require("../../utils/gallery/24.webp")
    // },
    // {
    //   img:require("../../utils/gallery/25.webp")
    // },
    // {
    //   img:require("../../utils/gallery/26.webp")
    // },
    // {
    //   img:require("../../utils/gallery/27.webp")
    // },
    // {
    //   img:require("../../utils/gallery/28.webp")
    // },
    // {
    //   img:require("../../utils/gallery/29.webp")
    // },
    // {
    //   img:require("../../utils/gallery/30.webp")
    // },
    // {
    //   img:require("../../utils/gallery/31.webp")
    // },
    // {
    //   img:require("../../utils/gallery/32.webp")
    // },
    // {
    //   img:require("../../utils/gallery/33.webp")
    // },
    // {
    //   img:require("../../utils/gallery/34.webp")
    // },
    // {
    //   img:require("../../utils/gallery/35.webp")
    // },
    // {
    //   img:require("../../utils/gallery/36.webp")
    // },
    // {
    //   img:require("../../utils/gallery/37.webp")
    // },
    // {
    //   img:require("../../utils/gallery/38.webp")
    // },
    // {
    //   img:require("../../utils/gallery/39.webp")
    // },
    // {
    //   img:require("../../utils/gallery/40.webp")
    // },
    // {
    //   img:require("../../utils/gallery/41.webp")
    // },
    // {
    //   img:require("../../utils/gallery/42.webp")
    // },
    // {
    //   img:require("../../utils/gallery/43.webp")
    // },
    // {
    //   img:require("../../utils/gallery/44.webp")
    // },
    // {
    //   img:require("../../utils/gallery/45.webp")
    // },
    // {
    //   img:require("../../utils/gallery/46.webp")
    // },
    // {
    //   img:require("../../utils/gallery/47.webp")
    // },
    // {
    //   img:require("../../utils/gallery/48.webp")
    // },
    // {
    //   img:require("../../utils/gallery/49.webp")
    // },
    // {
    //   img:require("../../utils/gallery/50.webp")
    // },
    // {
    //   img:require("../../utils/gallery/51.webp")
    // },
    // {
    //   img:require("../../utils/gallery/52.webp")
    // },
    // {
    //   img:require("../../utils/gallery/53.webp")
    // },
    // {
    //   img:require("../../utils/gallery/54.webp")
    // },
    // {
    //   img:require("../../utils/gallery/55.webp")
    // },
    // {
    //   img:require("../../utils/gallery/56.webp")
    // },
    // {
    //   img:require("../../utils/gallery/57.webp")
    // },
    // {
    //   img:require("../../utils/gallery/58.webp")
    // },
    // {
    //   img:require("../../utils/gallery/59.webp")
    // },
    // {
    //   img:require("../../utils/gallery/60.webp")
    // },
    // {
    //   img:require("../../utils/gallery/61.webp")
    // },
    // {
    //   img:require("../../utils/gallery/62.webp")
    // },
    // {
    //   img:require("../../utils/gallery/63.webp")
    // },
    // {
    //   img:require("../../utils/gallery/64.webp")
    // },
    // {
    //   img:require("../../utils/gallery/65.webp")
    // },
    // {
    //   img:require("../../utils/gallery/66.webp")
    // },
    // {
    //   img:require("../../utils/gallery/67.webp")
    // }
  ];
  
  export default slides;
  